/**
 * Ищем контейнер
 * @param target
 * @returns {*}
 */
function findContainer(target) {
	if (!target) return false;
	return document.querySelector(target)
}

/**
 * Вытаскиваем все дата атрибуты у элемента
 * @param node
 * @param isRemoveDataName
 * @returns {{}}
 */
function getDataAttributes(node, isRemoveDataName = false) {
	if (!node) return false;

	let obj = {},
		arr = [].filter.call(node.attributes, function (at) {
			return /^data-/.test(at.name);
		});

	if (arr.length) {
		arr.forEach(function (v) {
			let name = v.name;
			if (isRemoveDataName) name = name.slice(5);
			obj[name] = v.value
		});
	}

	return obj;
}

/**
 * Получаем массив из строки
 * @param string
 * @param isInt
 * @returns {*}
 */
function setParamArray(string, isInt = false) {
	let arr = string.split(',');

	if (isInt) {
		return arr.map((item) => {
			return parseInt(item)
		})
	} else {
		return  arr;
	}
}

/**
 * Глубокое объединение объектов
 * @param objects
 * @returns {*}
 */
function mergeDeepObject(...objects) {
	const isObject = obj => obj && typeof obj === 'object';

	return objects.reduce((prev, obj) => {
		Object.keys(obj).forEach(key => {
			const pVal = prev[key];
			const oVal = obj[key];

			if (Array.isArray(pVal) && Array.isArray(oVal)) {
				prev[key] = pVal.concat(...oVal);
			}
			else if (isObject(pVal) && isObject(oVal)) {
				prev[key] = mergeDeepObject(pVal, oVal);
			}
			else {
				prev[key] = oVal;
			}
		});

		return prev;
	}, {});
}

export {findContainer, getDataAttributes, setParamArray, mergeDeepObject}
